 /* eslint-disable */
import { CommonGet,CommonPost } from '../helpers/HttpClient';

export default {
    getAllProvice,
    getDistritcsByProvince,
    getCitiesbyDistrict
};

async function getAllProvice() {
    const response = await CommonGet('/api/Province/GetAllProvince', null);
    return response.data;
}

async function getDistritcsByProvince(provinceID) {
    const response = await CommonGet('/api/District/GetAllDistrictByProvinceID', 'provinceID=' + provinceID);
    return response.data;
}

async function getCitiesbyDistrict(provinceID,districtID) {
    const response = await CommonGet('/api/City/GetCityByProvinceIDDistrictID', 'provinceID=' + provinceID + '&districtID=' + districtID);
    return response.data;
}

